export default {"src":"/_next/static/media/prag-logo-dark.ad57f7cd.svg","height":91,"width":240,"blurWidth":0,"blurHeight":0};